import { Box } from '@mui/material';
import { Check } from '@mui/icons-material';
import List from '@mui/material/List';
import * as O from 'fp-ts/Option';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { Fixtuur } from '@fixtuur/backpack';
import * as ProductCard from './O_ProductCard';
import * as ProductDrawerNavigation from './O_ProductDrawerNavigation';
import * as Ui from './domain';
import { ProductCard as PC } from './domain';
import { WarningChange } from './icons/warningChange';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    var compatibleProductCards = Hooks.useMemo(function () { var _a; return (_a = p.productCards.filter(function (pc) { return pc.status === 'none' || pc.status === 'selected'; })) !== null && _a !== void 0 ? _a : []; }, [p.productCards]);
    var incompatibleProductCards = Hooks.useMemo(function () { var _a; return (_a = p.productCards.filter(function (pc) { return pc.status === 'incompatible'; })) !== null && _a !== void 0 ? _a : []; }, [p.productCards]);
    var _a = Hooks.useState(compatibleProductCards.length === 0 ? 1 : 0), activeProductCardTab = _a[0], setActiveProductCardTab = _a[1];
    var compatibilityTabs = [
        {
            tabLabel: t('product.tab.compatible'),
            disabled: compatibleProductCards.length === 0,
            icon: Preact.h(Check, null),
            iconPosition: 'start',
        },
        {
            tabLabel: t('product.tab.incompatible'),
            disabled: incompatibleProductCards.length === 0,
            icon: Preact.h(WarningChange, null),
            iconPosition: 'start',
        },
    ];
    var sortedCards = Hooks.useMemo(function () {
        return Ui.ProductCard.sortByProductProperties(activeProductCardTab === 1 ? incompatibleProductCards : compatibleProductCards);
    }, [incompatibleProductCards, compatibleProductCards, activeProductCardTab]);
    var _b = Hooks.useState(null), pendingSelectedProduct = _b[0], setPendingSelectedProduct = _b[1];
    Hooks.useEffect(function () {
        var selectedCard = p.productCards.find(function (card) { return card.status === 'selected'; });
        if (selectedCard) {
            var selectedProductId = PC.productIdFromGood(selectedCard.good);
            if (selectedProductId === (pendingSelectedProduct === null || pendingSelectedProduct === void 0 ? void 0 : pendingSelectedProduct.productId) &&
                p.selectedPartId === pendingSelectedProduct.partId) {
                setPendingSelectedProduct(null);
            }
        }
    }, [p.productCards, pendingSelectedProduct, p.selectedPartId]);
    var onApplyClick = function (productId, partId) {
        setPendingSelectedProduct({ productId: productId, partId: partId });
    };
    return (Preact.h(Box, { sx: {
            width: '100%',
            height: '100%',
            backgroundColor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
        }, "data-testid": "product-card-container" },
        Preact.h(ProductDrawerNavigation.Component, { onCloseClick: p.topNavigation.onCloseClick, onBackClick: p.topNavigation.onBackClick, tabGroup: {
                tabs: compatibilityTabs,
                activeTabValue: activeProductCardTab,
                setTabValue: function (value) {
                    setActiveProductCardTab(value);
                },
                trackCompatibility: p.onTabChange,
            }, disableClose: p.topNavigation.disableClose }),
        Preact.h(List, { sx: {
                display: 'grid',
                overflowY: 'auto',
                paddingX: '12px',
                rowGap: '16px',
                columnGap: '8px',
                gridTemplateColumns: {
                    xs: '1fr 1fr',
                    sm: '1fr 1fr 1fr',
                    md: '1fr 1fr',
                },
            } }, sortedCards.map(function (pr) {
            var details = Ui.ProductCard.getProductDetails(pr.good, p.formatCurrency);
            return (Preact.h(ProductCard.Component, { productCard: pr, productCardDetails: details, onClick: function () {
                    var _a;
                    onApplyClick(PC.productIdFromGood(pr.good), p.selectedPartId);
                    p.onProductCardClick(O.toNullable(Fixtuur.Good.id(pr.good)), (_a = details === null || details === void 0 ? void 0 : details.price) !== null && _a !== void 0 ? _a : null, pr.status === 'incompatible' ? false : true);
                }, pendingSelection: pendingSelectedProduct, hidePrice: p.hidePrice, trackMoreInfo: p.trackMoreInfo }));
        }))));
};
Component.displayName = 'ProductDrawer';
